<template>
  <div class="my_container" :class="mobileOnOff ? 'mobile_container' : ''">
    <div v-if="!mobileOnOff" class="my_breadcrumb_box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item v-if="breadcrumb === 'community'" :to="{ name: 'Community' }">社区生态</el-breadcrumb-item>
        <el-breadcrumb-item v-if="breadcrumb === 'union'" :to="{ path: '/unionNav' }">联盟生态</el-breadcrumb-item>
        <el-breadcrumb-item v-if="breadcrumb === 'research'" :to="{ path: '/researchNav' }">研究院生态</el-breadcrumb-item>
        <el-breadcrumb-item :to="breadcrumbPath">{{breadcrumbName}}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="detail !== null">{{detail.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div v-if="!mobileOnOff">
      <div class="glag_left">
          <div v-if="detail !== null" class="text_detail_box">
            <div class="text_detail_title">
              <p>{{detail.title}}</p>
              <p class="text_detail_time">发布时间：{{detail.add_time}}</p>
              <p class="text_detail_tag">标签：
                <span v-for="item in detail.tag" :key="item.id">{{item.tag_name}}</span>
              </p>
            </div>
            <div class="text_detail_video">
              <video-view :src-arr="detail.video_path" :bg-img="detail.bg_img_path"></video-view>
            </div>
            视频简介：
            <div class="text_detail_content" v-html="detail.content"></div>
            <div class="text_detail_address" v-if="detail.type === '2'">
              <span>文章转载自：{{detail.address}}</span>
            </div>
            <div class="expert_list_other rt">
              <share-view :detail="detail"></share-view>
            </div>
          </div>
          <comment-view
          v-if="childOnOff"
          :comments = "comment"
          :list-id = "listId"
          :user = "user"
          :mescount = "detail.mes_count"
          :participatecount = "detail.participate_count"
          ></comment-view>
      </div>
      <div class="glag_right">
        <recommend-view v-if="recommendList !== null" :list="recommendList"></recommend-view>
      </div>
    </div>
    <div v-else>
      <detail-mobile-view></detail-mobile-view>
    </div>
  </div>
</template>

<script>
import video from '../Public/video.vue'
import comment from '../Public/comment.vue'
import recommend from '../Public/detailRecommendList.vue'
import share from '../Public/share.vue'
import detailM from '../Mobile/detailM.vue'
export default {
  components: {
    videoView: video,
    commentView: comment,
    recommendView: recommend,
    shareView: share,
    detailMobileView: detailM
  },
  data () {
    return {
      navId: '', // 所属模块id
      breadcrumb: '', // 模块信息
      breadcrumbName: '', // 模块名字
      breadcrumbPath: '', // 模块地址
      breadcrumbId: '', // 模块id
      listId: '', // 详情id
      unionId: '', // 联盟id
      mobileOnOff: false, // 判断是否为手机登录
      childOnOff: false, // 子组建渲染开关
      detail: null, // 文章详情
      user: {}, // 作者信息
      comment: {
        comments: []
      }, // 评论列表
      recommendList: null, // 相关内容推荐
      shareOnOff: false // 分享弹窗开关
    }
  },
  created () {
    const vueThat = this
    vueThat.navId = vueThat.$route.query.nav
    vueThat.listId = vueThat.$route.query.id
    vueThat.getInfo()
  },
  methods: {
    // 获取页面内容
    getInfo () {
      const vueThat = this
      const breadcrumbInfo = vueThat.mycommon.navJudge(vueThat.navId)
      vueThat.breadcrumb = breadcrumbInfo.breadcrumb
      vueThat.breadcrumbName = breadcrumbInfo.breadcrumbName
      let info = null
      if (vueThat.navId === '5' || vueThat.navId === '6' || vueThat.navId === '7') {
        vueThat.myApi.videoDetails({ list_id: vueThat.listId })
          .then(function (res) {
            if (res.data.code === 200) {
              info = res.data.data
              vueThat.detail = info.data
              vueThat.childOnOff = true
              vueThat.comment.comments = info.mes
              vueThat.recommendList = info.right
              // 面包屑跳转参数赋值
              vueThat.breadcrumbId = vueThat.navId
              vueThat.breadcrumbPath = {
                path: breadcrumbInfo.path,
                query: { nav: vueThat.breadcrumbId }
              }
            }
          }).catch(function (erro) {})
      } else if (vueThat.navId === '8') {
        vueThat.myApi.communityMemberDetails({ list_id: vueThat.listId }).then((res) => {
          if (res.data.code === 200) {
            vueThat.detail = res.data.data.data
            vueThat.childOnOff = true
            vueThat.comment.comments = res.data.data.mes_data
            vueThat.recommendList = res.data.data.right
            // 面包屑数据
            vueThat.breadcrumbId = vueThat.navId
            vueThat.breadcrumbPath = {
              path: breadcrumbInfo.path
            }
          }
        })
      } else if (vueThat.navId === '15') {
        vueThat.breadcrumb = 'union'
        vueThat.breadcrumbName = '研讨沙龙'
        vueThat.myApi.forumDetails({ list_id: vueThat.listId }).then((res) => {
          if (res.data.code === 200) {
            info = res.data.data
            vueThat.detail = info.data
            vueThat.childOnOff = true
            vueThat.comment.comments = info.mes_data
            vueThat.recommendList = info.right
            // 面包屑跳转参数赋值
            vueThat.breadcrumbId = vueThat.detail.union_id
            vueThat.breadcrumbPath = {
              path: breadcrumbInfo.path,
              query: { id: vueThat.breadcrumbId }
            }
          }
        })
      } else if (vueThat.navId === '14') {
        vueThat.breadcrumb = 'union'
        vueThat.breadcrumbName = '培训'
        vueThat.myApi.getTrainDetails({ list_id: vueThat.listId }).then((res) => {
          if (res.data.code === 200) {
            info = res.data.data
            vueThat.detail = info.data
            vueThat.childOnOff = true
            vueThat.comment.comments = info.mes_data
            vueThat.recommendList = info.right
            // 面包屑跳转参数赋值
            vueThat.breadcrumbId = vueThat.detail.union_id
            vueThat.breadcrumbPath = {
              path: breadcrumbInfo.path,
              query: { id: vueThat.breadcrumbId }
            }
          }
        })
      } else if (vueThat.navId === '16') {
        vueThat.breadcrumb = 'union'
        vueThat.breadcrumbName = '项目路演'
        vueThat.myApi.getTrainDetails({ list_id: vueThat.listId }).then((res) => {
          if (res.data.code === 200) {
            info = res.data.data
            vueThat.detail = info.data
            vueThat.childOnOff = true
            vueThat.comment.comments = info.mes_data
            vueThat.recommendList = info.right
            // 面包屑跳转参数赋值
            vueThat.breadcrumbId = vueThat.detail.union_id
            vueThat.breadcrumbPath = {
              path: breadcrumbInfo.path,
              query: { id: vueThat.breadcrumbId }
            }
          }
        })
      }
    },
    // 相关内容跳转
    jump (rid, navId) {
      let path = ''
      if (navId === 8) {
        path = '/expertDetail/:id'
      }
      const routeData = this.$router.resolve({
        path: path,
        query: { id: rid }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style>
</style>
